import type { ProfileProject } from "../models";

/**
 * Sorts projects with default projects first, then alphabetically
 */
export function sortProjects(projects: ProfileProject[]): ProfileProject[] {
  return [...projects].sort((a, b) => {
    // Default projects first
    if (a.is_default && !b.is_default) {
      return -1;
    }
    if (!a.is_default && b.is_default) {
      return 1;
    }
    // Then alphabetically
    return a.name.localeCompare(b.name);
  });
}
